import { OperatingSystemType } from './../../../constant/device.constant';
import { UtilService } from 'src/app/util/UtilService';
import { PageConstant } from './../../../constant/page.constant';
import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class SelectInfoLayoutComponent implements OnInit {
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  @Input() currentLanguage = 'en';
  menu_icons: any;
  common_icons: any;
  isMac = '';
  version = '';
  public optionImage: Object = {
    image_0: 'option_unselect',
    image_1: 'option_select',
  };

  infoArr: any[] = [
    {
      name: 'LANG00145',
      methodName: 'info_new_openFullColorCards',
      selected: 0,
    },
    {
      name: 'LANG00126',
      methodName: 'info_popup_fc21',
      selected: 0,
    },
    {
      name: 'LANG00127',
      methodName: 'info_popup_fcb',
      selected: 0,
    },
    {
      name: 'LANG00144',
      methodName: 'info_new_openFullColorGames',
      selected: 0,
    },
    {
      name: 'LANG00146',
      methodName: 'info_new_openVideoTutorial',
      selected: 0,
    },
  ];

  constructor(
    public utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService
  ) {
    this.isMac =
      this.utilService.getOSType() !== OperatingSystemType.MAC ? '' : 'mac';

    this.menu_icons = SpriteConstant.MENU_ICONS;
    this.common_icons = SpriteConstant.COMMON_ICONS;
  }

  buttonOverOrOut(value) {
    const len = this.infoArr.length;
    for (let i = 0; i < len; i++) {
      if (i !== value) {
        this.infoArr[i].selected = 0;
      }
    }
    this.infoArr[value].selected = this.infoArr[value].selected === 0 ? 1 : 0;
  }

  buttonClick(value) {
    this.eventEmit.emit(this.infoArr[value].methodName);
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };

  ngOnInit() {
    this.version = PageConstant.VERSION;
  }
}
